import { render, staticRenderFns } from "./SellerLogoSection.vue?vue&type=template&id=a33802d8&scoped=true"
import script from "./SellerLogoSection.vue?vue&type=script&lang=js"
export * from "./SellerLogoSection.vue?vue&type=script&lang=js"
import style0 from "./SellerLogoSection.vue?vue&type=style&index=0&id=a33802d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33802d8",
  null
  
)

export default component.exports